import { MealNurseryDomainService } from './domain';
import { MealFactory } from './entity/mealFactory';

import type { Logger } from '@/infra/logger';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { MealJson } from '@/types/domain/meal/entities/mealEntity';

/**
 * 食事アプリケーションサービス(施設)
 */
export class MealNurseryApplicationService {
  private service!: MealNurseryDomainService;

  private mealFactory = new MealFactory();

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   * @param logger logger
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
    logger: Logger,
  ) {
    this.service = new MealNurseryDomainService(logger);
    this.service.inject(wagakoNurseryApi);
  }

  /**
   * sendNurseryMeal
   * @param input input
   */
  async sendNurseryMeal(
    input: MealJson,
  ) {
    const entity = this.mealFactory.createFromJson(input);
    await this.service.sendNurseryMeal(entity);
  }

  /**
   * removeNurseryMeal
   * @param input input
   */
  async removeNurseryMeal(
    input: MealJson,
  ) {
    const entity = this.mealFactory.createFromJson(input);
    await this.service.removeNurseryMeal(entity);
  }
}
